// removed by extract-text-webpack-plugin
module.exports = {"lightbox":"x7pvVXYmIEB_Iesg_YG0a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Material/material.scss
// module id = 755
// module chunks = 0